import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { AdapterFindInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-find.dto';
import type { AdapterPageInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-page.dto';
import type { AdapterQueryInterface } from '@zaoblako/shared/modules/traffic/dtos/adapter/adapter-query.dto';

import { Injectable } from '@angular/core';
import { concatMap, type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrafficAdapterService extends BaseService {
  protected baseUrl = '/traffic/adapter';

  public getDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findWithPagination(queryParams: AdapterQueryInterface, descriptor?: ReportDescriptorInterface): Observable<AdapterPageInterface> {
    if (descriptor?.subroutes?.items) {
      return this.http.get<AdapterPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
        params: this.objectToHttpParams(queryParams)
      });
    } else {
      return this
        .getDescriptor()
        .pipe(concatMap((descriptor) => this.http.get<AdapterPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
          params: this.objectToHttpParams(queryParams)
        })))
    }
  }

  public getHistory(id: number, queryParams: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<AdapterFindInterface> {
    return this.http.post<AdapterFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
